import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  MdDelete,
  MdDocumentScanner,
  MdEdit,
  MdFolder,
  MdOutlineRemoveRedEye,
  MdWarning,
} from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import {
  findAllByClient,
  deleteOne,
} from "../../../../services/Salarie__Service";
import { findOne } from "../../../../services/Client__Service";
import BtnAddSalarie from "../Salarie/BtnAddSalarie/BtnAddSalarie";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import Modal from "../../../Modal/Modal";
import Form from "../Client/components/Form/Form";
import FormSalarie from "../Salarie/Form/FormSalarie";
import CardClient from "../../../CardClient/CardClient";
import ImportSalaries from "./ImportSalaries";
import { Button } from "@mui/material";

const ListSalarieForOneClient = () => {
  /* Handle Modal */
  const [viewClientId, setViewClientId] = useState(0);
  const [viewSalarieId, setViewSalarieId] = useState(0);
  /* End Handle Modal */

  const [client, setClient] = useState(null);
  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);
  const redirect = useNavigate();

  const handleEdit = React.useCallback(
    (id) => () => {
      redirect(`/main/salarie/edit/${id}`);
    },
    []
  );

  const handleDelete = React.useCallback(
    (id) => () => {
      setIdDelete(id);
    },
    []
  );

  const columns = useMemo(
    () => [
      {
        field: "Image",
        headerName: "",
        valueGetter: (params) => {
          return params.row.chemin ? params.row.chemin : null;
        },
        cellClassName: "img-data-grid",
        renderCell: (params) =>
          params.value && (
            <img className="img-data-grid" src={params.value} alt="" />
          ),
      },
      { field: "matricule", headerName: "Matricule", minWidth: 150 },
      { field: "nom", headerName: "Nom", minWidth: 150 },
      { field: "prenom", headerName: "Prénom", minWidth: 150 },
      {
        field: "email",
        headerName: "Email",
        width: 150,
        flex: 1,
        valueGetter: (params) => {
          return `${params.row.email1}`;
        },
      },
      {
        field: "telephone",
        headerName: "Téléphone",
        width: 150,
        valueGetter: (params) => {
          return `${params.row.tel1}`;
        },
      },
      {
        field: "client",
        headerName: "Client",
        minWidth: 200,
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => setViewClientId(client.id)}
          >
            {params.value}
          </p>
        ),
        valueGetter: (params) => {
          return client.nom;
          // return `${params.row.employeurName}`;
        },
      },
      {
        field: "statut",
        headerName: "Statut",
        type: "boolean",
        width: 100,
        valueGetter: (params) => {
          return parseInt(params.row.statut) === 1;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewSalarieId(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdEdit />}
            label="Modifier"
            onClick={handleEdit(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdDocumentScanner />}
            label="Bulletins"
            onClick={() => {
              redirect(`/main/salarie/view/documents/${params.id}`);
            }}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdFolder />}
            label="Dossiers"
            onClick={() => {
              redirect("/main/salarie/" + params.id + "/folder/");
            }}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdDelete />}
            label="Supprimer"
            onClick={handleDelete(params.id)}
            showInMenu
          />,
        ],
      },
    ],
    [handleDelete, handleEdit, redirect, client]
  );

  const [salries, setSalaries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [idDelete, setIdDelete] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const handleSubmitDelete = () => {
    deleteOneSalarie(idDelete);
    setIdDelete(0);
    setIsDeleteLoading(true);
  };

  useEffect(() => {
    if (client !== null) {
      nav({
        links: [
          {
            href: "/main/client",
            linkname: "Clients",
          },
          {
            href: "",
            linkname: client.nom,
          },
        ],
        children: <BtnAddSalarie />,
      });
    }

    if (client === null) {
      fetchOneClient(id);
    }
  }, [client]);

  const fetchOneClient = async (id) => {
    findOne(id)
      .then((response) => {
        setClient(response.data);
        fetchAllSalarie(id);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const fetchAllSalarie = async (id) => {
    findAllByClient(id)
      .then((response) => {
        setSalaries(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteOneSalarie = async (id) => {
    deleteOne(id)
      .then(() => {
        setIsDeleteLoading(false);
        setIsLoading(true);
        setSalaries([]);
        fetchAllSalarie();
        notify("Supprimé avec succès", "success");
      })
      .catch((error) => {
        setIsDeleteLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  const [openImport, setOpenImport] = useState(false);

  return (
    <Fragment>
      {openImport && (
        <ImportSalaries
          open={openImport}
          onClose={() => {
            fetchAllSalarie(client.id);
            setOpenImport(false);
          }}
          client={client}
        />
      )}
      <div className="salarie__items">
        <CardClient initialClient={client} />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <h3>Liste des salariés</h3>
          <Button
            onClick={() => {
              setOpenImport(true);
            }}
          >
            Importer
          </Button>
        </div>
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={salries}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isDeleteLoading && <Loader loadingMsg="Suppression en cours" />}
      {idDelete !== 0 && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Êtes-vous sûr (e) de vouloir supprimer ce salarié ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention !!! Toutes les données de ce salarié seront perdues.
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitDelete}>
                Oui
              </button>
              <button className="btn" onClick={() => setIdDelete(0)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {viewClientId !== 0 && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Client</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewClientId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form clientId={viewClientId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewClientId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {viewSalarieId !== 0 && (
        <Modal>
          <div className={`modal ${viewSalarieId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Salarié</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewSalarieId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormSalarie salarieId={viewSalarieId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewSalarieId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListSalarieForOneClient;
